import { ExperimentFeature } from '@fullstory/proto/fs/services/orgs';
import { Flag } from '@fullstory/proto/fs/shared/flags';
import { useFlags } from '@fullstory/react-hooks';
import { useMemo } from 'react';
import { useExperimentConfig } from './useExperimentConfig';

export const useAiSuggestionsExploreEnabled = (): boolean => {
  const flags = useFlags();
  const { experimentOptedOut } = useExperimentConfig();
  return useMemo(
    () =>
      flags.featureFlags().AppAiSuggestionsExplorations &&
      flags.hasBit(Flag.FeatSuggestedElements) &&
      !experimentOptedOut[ExperimentFeature.FEATURE_SUGGESTED_ELEMENTS],
    [flags, experimentOptedOut],
  );
};
